export default "__VITE_ASSET__8NW5CM9h__"